import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop';
import Inicio from './pages/Inicio/Inicio';
import Pesquisas from './pages/Pesquisas/Pesquisas';
import Documentos from './pages/Documentos/Documentos';
import Noticias from './pages/Noticias/Noticias';
import Sobre from './pages/Sobre/Sobre';
import Contato from './pages/Contato/Contato';

function App() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const appStyles = {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column'
  };

  const mainContentStyles = {
    flex: 1,
    paddingTop: isMobile ? '0px' : '0px'
  };

  return (
    <Router>
      <ScrollToTop />
      <div style={appStyles}>
        <Navbar />
        <main style={mainContentStyles}>
          <Routes>
            <Route path="/" element={<Inicio />} />
            <Route path="/pesquisas" element={<Pesquisas />} />
            <Route path="/documentos" element={<Documentos />} />
            <Route path="/noticias" element={<Noticias />} />
            <Route path="/sobre" element={<Sobre />} />
            <Route path="/contato" element={<Contato />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
